var map = {
	"./csr-1 (1).jpg": 394,
	"./csr-1 (2).jpg": 895,
	"./csr-1 (3).jpg": 3708,
	"./csr-1 (4).jpg": 3681,
	"./csr-1 (5).jpg": 8870,
	"./csr-2 (1).jpg": 5269,
	"./csr-2 (2).jpg": 3932,
	"./csr-2 (3).jpg": 6815,
	"./csr-2 (4).jpg": 7782,
	"./csr-2 (5).jpg": 369,
	"./csr-3 (1).jpg": 4180,
	"./csr-3 (2).jpg": 2653,
	"./csr-3 (3).jpg": 7682,
	"./csr-3 (4).jpg": 8003,
	"./csr-4 (1).jpg": 559,
	"./csr-4 (2).jpg": 1610,
	"./csr-4 (3).jpg": 9013,
	"./csr-4 (4).jpg": 7736,
	"./csr-5 (1).jpg": 8350,
	"./csr-5 (2).jpg": 8995,
	"./csr-5 (3).jpg": 8224,
	"./csr-5 (4).jpg": 3645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1090;